import React, { useState } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { modal } from "../../../../util";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import SponsorsCategoryForm from "../sponsorsCategoryForm";
import DragAndDropTable from "../../../common/DragAndDropTable";

const formatDatetime = (dt) => {
  return dayjs(dt).format("DD MMM YYYY, hh:mma");
};

const SponsorsCategoryListingPage = ({ disabled, match }) => {
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [biggestSeq, setBiggestSeq] = useState(0);


  const getSponsorsCategory = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getSponsorsCategory(
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        searchString
      );
      setRows(result.data.content.filter((x) => x));
      setTotalElements(result.data.totalElements);
      setTotalPages(result.data.totalPages);
      if (pageIndex === 0 && result.data.content[0]) {
        setBiggestSeq(result.data.content[0].seq);
      };
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, pageSize, searchString, setLoading]);

  React.useEffect(() => {
    if(pageSize) getSponsorsCategory();
  }, [getSponsorsCategory]);

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const handleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete File",
      text: "Are you sure to delete this category?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.hkiff.deleteSponsorsCategoryById(id);
        toast.dark("The category is deleted.");
        await getSponsorsCategory();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const bulkDelete = (ids) => {
    const promises = ids.map((id) => apiHelper.hkiff.deleteSponsorsCategoryById(id));
    return Promise.all(promises);
  };

  const saveOrdering = async () => {
    try {
      const seqData = {};
      rows.forEach((e, i) => {
        seqData[e.id] = pageIndex * pageSize + i;
      });

      console.log("seqData:", seqData);

      const result = await apiHelper.hkiff.orderSponsorsCategories(
        seqData
      );
      if (result.data.code === 0) {
        toast.dark("Your changes are saved.");
        getSponsorsCategory();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name (English)",
        accessor: "localizations.en.name",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.en.name}
            </Link>
          );
        },
      },
      {
        Header: "Name (Traditional Chinese)",
        accessor: "localizations.tc.name",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.tc.name}
            </Link>
          );
        },
      },
      {
        Header: "Last Update",
        accessor: "updateTime",
        Cell: ({ row }) => {
          return formatDatetime(row.original.updateTime);
        },
      },
    ],
    []
  );

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Sponsors &gt; Sponsors Category
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <SponsorsCategoryForm
            description="Add New Category"
            submitBtnTxt="Add New Category"
            gridSize={4}
            fetchData={getSponsorsCategory}
            disabled={disabled}
            biggestSeq={biggestSeq}
            setBiggestSeq={setBiggestSeq}
          />
        </Grid>
        <Grid item xs={8}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getSponsorsCategory}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={bulkDelete}
            subject="category"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            editDeleteAction={true}
            handleDelete={handleDelete}
            withPagination={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SponsorsCategoryListingPage;
